import "./Resume.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import useResumeData from "../hooks/useResumeData";

const ResumeTimeline = () => {
    const resumeData = useResumeData();

    return (
        <div className="resume-container">
            <div className="resume-header">
                <span className="resume-eyebrow">Career</span>
                <h2 className="resume-title">Resume</h2>
                <p className="resume-subtitle">Experience and education highlights</p>
            </div>

            <div className="timeline" role="list">
                {resumeData.map((item, index) => (
                    <article key={index} className="timeline-item" role="listitem">
                        <div className="timeline-left">
                            <div className="timeline-icon">
                                <FontAwesomeIcon icon={item.icon} />
                            </div>
                            <div className="timeline-line" />
                        </div>

                        <div className="timeline-content">
                            <div className="timeline-meta">
                                <span className="timeline-year">{item.year}</span>
                            </div>
                            <h3 className="timeline-title">{item.title}</h3>

                            {item.description && (
                                <p className="timeline-section-label">{item.description}</p>
                            )}
                            {item.summary && (
                                <ul className="timeline-list">
                                    {item.summary.map((point, idx) => (
                                        <li key={idx}>{point}</li>
                                    ))}
                                </ul>
                            )}
                            {item.additionalDescription && (
                                <p className="timeline-section-label" style={{ marginTop: "1rem" }}>
                                    {item.additionalDescription}
                                </p>
                            )}
                            {item.additionalSummary && (
                                <ul className="timeline-list">
                                    {item.additionalSummary.map((point, idx) => (
                                        <li key={idx}>{point}</li>
                                    ))}
                                </ul>
                            )}
                        </div>
                    </article>
                ))}
            </div>
        </div>
    );
};

export default ResumeTimeline;